'use client';

import { c as _c } from "react/compiler-runtime";
import FormModal from '@components/form-modal/FormModal';
import Header from '@components/header/Header';
import MenuMobile from '@components/menu-mobile/MenuMobile';
import PanoramaModal from '@components/panorama-modal/PanoramaModal';
import { menuMobileSelector, panoramaModelSelector } from '@lib/store/slices/ComponentsSlice';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import GallerySliderMobile from 'src/app/gallery/components/gallery-slider-mobile/GallerySliderMobile';
import SwiperCore from 'swiper';
import { FreeMode, Mousewheel } from 'swiper/modules';
import style from './GalleryTemplate.module.scss';
SwiperCore.use([FreeMode, Mousewheel]);
export default function GalleryTemplate(t0) {
  const $ = _c(8);
  const {
    children,
    pageData,
    isMobile
  } = t0;
  const openPanoramaModel = useSelector(panoramaModelSelector);
  const openMenuMobile = useSelector(menuMobileSelector);
  const containerRef = useRef(null);
  const {
    isLandscape,
    viewport
  } = useViewport();
  let t1;
  if ($[0] !== children || $[1] !== isLandscape || $[2] !== isMobile || $[3] !== openMenuMobile || $[4] !== openPanoramaModel || $[5] !== pageData || $[6] !== viewport) {
    t1 = <>{isMobile ? <>{!isLandscape ? <>{openMenuMobile && <MenuMobile />}{openPanoramaModel && <PanoramaModal />}<FormModal /><div ref={containerRef} className="App"><Header isMobile={isMobile} viewport={viewport} />{children}<GallerySliderMobile gallery={pageData} /></div></> : <div className={style.layoutPlug}>Для корректной работы сайта, пожалуйста, переверните устройство</div>}</> : <>{children}</>}</>;
    $[0] = children;
    $[1] = isLandscape;
    $[2] = isMobile;
    $[3] = openMenuMobile;
    $[4] = openPanoramaModel;
    $[5] = pageData;
    $[6] = viewport;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}